// extracted by mini-css-extract-plugin
module.exports =  {"popover-trigger-wrapper":"D5Dok20","popoverTriggerWrapper":"D5Dok20","hide-trigger":"P20Gy4q","hideTrigger":"P20Gy4q"};